class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  connectedCallback() {
    if (!this.header || !this.content.classList.contains('header__submenu--primary')) return;
    this.updateDropdownPosition = () => {
      const headerBottom = this.header.getBoundingClientRect().bottom;
      const detailsTop = this.mainDetailsToggle.getBoundingClientRect().top;
      this.mainDetailsToggle.style.setProperty('--hs-dropdown-top', `${headerBottom - detailsTop}px`);
    };
    this.dropdownResizeObserver = new ResizeObserver(this.updateDropdownPosition);
    this.dropdownResizeObserver.observe(this.header);
    this.dropdownResizeObserver.observe(this.mainDetailsToggle);
    this.addEventListener('mouseenter', this.updateDropdownPosition);
    this.addEventListener('focusin', this.updateDropdownPosition);
    this.updateDropdownPosition();
  }

  disconnectedCallback() {
    this.dropdownResizeObserver?.disconnect();
    if (!this.updateDropdownPosition) return;
    this.removeEventListener('mouseenter', this.updateDropdownPosition);
    this.removeEventListener('focusin', this.updateDropdownPosition);
  }

  onFocusOut() {
    setTimeout(() => {
      // Newsletter/modal focus traps can move focus away from the header while
      // the pointer is still over it. Keep the hovered menu open in that case.
      if (!this.contains(document.activeElement) && !this.matches(':hover')) this.close();
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
